<div
  odxLayout="grid gap-small"
  class="wrapper"
  [ngClass]="{
    'not-extended': extent() === SidesheetExtent.None,
    'partially-extended': extent() === SidesheetExtent.Partially,
    'fully-extended': extent() === SidesheetExtent.Fully,
  }"
>
  <div odxLayout="flex gap-none" class="flex-column content main">
    @if (isSignalElement(floorplanItem()) || isPlasticSign(floorplanItem())) {
      <span>{{ getProductId(floorplanItem()) }}</span>
    }

    @if (productId() || imageUrl()) {
      <div class="image-wrapper">
        @if (productId()) {
          <app-product-image
            [productId]="productId()"
            [imageUrl]="imageUrl()"
            [fallbackImageUrl]="fallbackImageUrl()"
          ></app-product-image>
        } @else {
          <app-standard-image [imageUrl]="imageUrl()" [fallbackImageUrl]="fallbackImageUrl()"></app-standard-image>
        }
      </div>
    }
    @if (displayNameForm) {
      <form odxForm [formGroup]="displayNameForm" [readonly]="floorplanItem().locked">
        <odx-form-field i18n-label="@@floorplan.details.form.item.name.label" label="Anzeigename auf dem Grundrissplan">
          <input
            formControlName="name"
            odxFormFieldControl
            i18n-placeholder="@@floorplan.details.form.displayname.placeholder"
            placeholder="Anzeigename"
            [readonly]="(isReadOnlyUser$ | async) === true || (hasWritePermission$ | async) === false || floorplanItem().locked"
          />
        </odx-form-field>
      </form>
    }

    <ng-content select="[data-main]"></ng-content>

    @if (notesForm) {
      <form odxForm [formGroup]="notesForm" [readonly]="floorplanItem().locked">
        <odx-form-field i18n-label="@@floorplan.details.textarea.label" label="Notizen">
          <textarea
            formControlName="notes"
            odxFormFieldControl
            i18n-placeholder="@@floorplan.details.textarea.placeholder"
            placeholder="Notizen"
            class="textarea-large"
          >
          </textarea>
          <ng-template odxFormFieldError>
            <ng-container i18n="@@floorplan.details.textarea.errorMessage.maxLengthExceeded"
              >Maximale Zeichenanzahl überschritten
            </ng-container>
          </ng-template>
        </odx-form-field>
      </form>
    }
    @if (showDiscontinuedWarning()) {
      <odx-inline-message variant="warning" i18n="@@floorplan.details.warning.discontinued">
        Enthält abgekündigte Komponenten
      </odx-inline-message>
    }
    @if (showIncompleteWarning()) {
      <odx-inline-message variant="warning" i18n="@@floorplan.details.warning.incomplete">
        Unvollständige Konfiguration
      </odx-inline-message>
    }
    @if ((isReadOnlyUser$ | async) === false) {
      <p class="odx-text--small locked-text">
        <odx-icon [name]="floorplanItem().locked ? 'lock' : 'unlock'" inline size="medium"></odx-icon>
        @if (!floorplanItem().locked) {
          <span i18n="@@floorplan.details.unlockedMessage"
            >Entsperrt am {{ floorplanItem().lockTimestamp | localizeDate }} um
            {{ floorplanItem().lockTimestamp | localizeTime }}</span
          >
        }
        @if (floorplanItem().locked) {
          <span i18n="@@floorplan.details.lockedMessage"
            >Gesperrt am {{ floorplanItem().lockTimestamp | localizeDate }} um
            {{ floorplanItem().lockTimestamp | localizeTime }}</span
          >
        }
      </p>
    }
  </div>
  <div odxLayout="flex gap-small separator left" class="flex-column content extended">
    <ng-content select="[data-extended]"></ng-content>
  </div>
  @if ((isReadOnlyUser$ | async) === false) {
    <div odxLayout="12 flex" class="buttons">
      @if (isExtendable()) {
        <app-extend-button [isExtended]="extent() !== SidesheetExtent.None" (buttonClicked)="toggleExtendedButtonClicked.emit()">
        </app-extend-button>
      }
      <app-toggle-item-text-visibility-button
        [itemTextVisible]="floorplanItem().itemTextVisible"
        (toggleEvent)="floorplanItem().updateItemTextVisibility($event)"
        [isSingleItem]="true"
      ></app-toggle-item-text-visibility-button>

      <app-toggle-lock-button
        [disabled]="(hasWritePermission$ | async) === false"
        [locked]="floorplanItem().locked"
        (toggleEvent)="floorplanItem().locked = $event"
        [isSingleItem]="true"
      >
      </app-toggle-lock-button>

      @if (duplicateEnabled()) {
        <app-duplicate-button (duplicate)="duplicate()"> </app-duplicate-button>
      }
      <app-delete-button (delete)="delete()" [disabled]="floorplanItem().locked || (hasWritePermission$ | async) === false">
      </app-delete-button>
    </div>
  }
</div>
